export default __webpack_public_path__ + "static/media/reduce-churn_loop.e5923dcc.gif";